const VIEWPORT_ORIGINAL_ATTR = 'data-app-viewport-original'
const NO_ZOOM_CLASS = 'app-no-zoom'

let enabled = false
let touchMoveHandler = null
let gestureHandler = null
let wheelHandler = null

function lockViewportMeta() {
  const viewport = document.querySelector('meta[name="viewport"]')
  if (!viewport || viewport.hasAttribute(VIEWPORT_ORIGINAL_ATTR)) return

  viewport.setAttribute(VIEWPORT_ORIGINAL_ATTR, viewport.getAttribute('content') || '')
  viewport.setAttribute(
    'content',
    'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover',
  )
}

function unlockViewportMeta() {
  const viewport = document.querySelector('meta[name="viewport"]')
  if (!viewport?.hasAttribute(VIEWPORT_ORIGINAL_ATTR)) return

  const original = viewport.getAttribute(VIEWPORT_ORIGINAL_ATTR)
  if (original) {
    viewport.setAttribute('content', original)
  }
  viewport.removeAttribute(VIEWPORT_ORIGINAL_ATTR)
}

/**
 * Disable pinch, double-tap, and trackpad zoom across all environments.
 */
export function enableTouchZoomGuard() {
  if (enabled) {
    return disableTouchZoomGuard
  }

  enabled = true
  document.documentElement.classList.add(NO_ZOOM_CLASS)
  lockViewportMeta()

  touchMoveHandler = (event) => {
    if (event.touches?.length > 1) {
      event.preventDefault()
    }
  }

  gestureHandler = (event) => {
    event.preventDefault()
  }

  wheelHandler = (event) => {
    if (event.ctrlKey) {
      event.preventDefault()
    }
  }

  document.addEventListener('touchmove', touchMoveHandler, { passive: false })
  document.addEventListener('gesturestart', gestureHandler, { passive: false })
  document.addEventListener('gesturechange', gestureHandler, { passive: false })
  document.addEventListener('gestureend', gestureHandler, { passive: false })
  document.addEventListener('wheel', wheelHandler, { passive: false })

  return disableTouchZoomGuard
}

export function disableTouchZoomGuard() {
  if (!enabled) return

  enabled = false
  document.documentElement.classList.remove(NO_ZOOM_CLASS)
  unlockViewportMeta()

  if (touchMoveHandler) {
    document.removeEventListener('touchmove', touchMoveHandler)
    touchMoveHandler = null
  }

  if (gestureHandler) {
    document.removeEventListener('gesturestart', gestureHandler)
    document.removeEventListener('gesturechange', gestureHandler)
    document.removeEventListener('gestureend', gestureHandler)
    gestureHandler = null
  }

  if (wheelHandler) {
    document.removeEventListener('wheel', wheelHandler)
    wheelHandler = null
  }
}
